export default __webpack_public_path__ + "static/media/b4.d5911abe.jpeg";